import { SaveOutlined } from '@ant-design/icons';
import {
  Button,
  Card,
  Col,
  Form,
  Input,
  message,
  Modal,
  Radio,
  Row,
  Select,
  Spin,
  TimePicker
} from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import CustomDatePicker from '../../components/CustomDatePicker';
import ResponsiveContainer from '../../components/ResponsiveContainer';
import { TIPOS_JOB } from '../../constants';
import { errorHandler } from '../../utils';
import { instanceRef } from '../../utils/axios';
import AseguradoraSelect from '../admins/componentes/AseguradoraSelect';

const { Option } = Select;

const formItemLayout = {
  labelCol: {
    xs: { span: 24 }
  },
  wrapperCol: {
    xs: { span: 24 }
  }
};

const JobForm = () => {
  const [form] = Form.useForm();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [model, setModel] = useState();
  const [aseguradora, setAseguradora] = useState();
  const [activo, setActivo] = useState(false);
  const [visible, setVisible] = useState(false);
  const [datosCambiados, setDatosCambiados] = useState({});
  const history = useHistory();

  const onFinish = async (values) => {
    try {
      const month = values.inicio.format('MM');
      const day = values.inicio.format('DD');
      const hour = values.hora_inicio.format('HH');
      const minute = values.hora_inicio.format('mm');
      const second = values.hora_inicio.format('ss');

      const hourEnd = values.hora_fin.format('HH');
      const minuteEnd = values.hora_fin.format('mm');
      const secondEnd = values.hora_fin.format('ss');

      const inicio = values.inicio.set({
        hour,
        minute,
        second
      });

      const fin = values.fin.set({
        hour: hourEnd,
        minute: minuteEnd,
        second: secondEnd
      });

      const expression = `${second} ${minute} ${hour}, ${hourEnd} ${day} ${month} *`;

      if (id) {
        setDatosCambiados({
          id,
          ...values
        });
        showModal();
      } else {
        const job = {
          id_aseguradora: aseguradora.value,
          inicio,
          fin,
          tipo: values.tipo,
          descripcion: values.descripcion,
          activo: false,
          cantidad: 0,
          fecha: moment(),
          expression
        };
        await instanceRef.instance.post(`job/`, job);
        message.success('Tarea Programada creada correctamente');
        history.push('/jobs');
      }
    } catch (error2) {
      errorHandler(error2);
    }
    setLoading(false);
  };

  const update = async () => {
    try {
      await instanceRef.instance.put(`job/${id}`, null);
      message.success('Tarea Programada actualizada correctamente');
      history.push('/jobs');
    } catch (error2) {
      errorHandler(error2);
    }
    setLoading(false);
  };

  function getAseguradoraId(newValue) {
    if (newValue && newValue.value) {
      setAseguradora(newValue);
    } else {
      setAseguradora();
    }
  }

  const loadAseguradora = async (idAseguradora) => {
    setLoading(true);
    try {
      await instanceRef.instance.get(`/aseguradoras/${idAseguradora}`);
      setLoading(false);
    } catch (error2) {
      errorHandler(error2);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (aseguradora?.value) {
      loadAseguradora(aseguradora?.value);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [aseguradora]);

  useEffect(() => {
    const loadModel = async () => {
      try {
        const response = await instanceRef.instance.get(`/job/${id}`);
        if (response.data?.data) {
          const jobModel = response.data?.data;
          setModel({
            ...response.data?.data,
            inicio: moment(jobModel.inicio),
            fin: moment(jobModel.fin),
            hora_inicio: moment(jobModel.inicio, 'HH:mm:ss'),
            hora_fin: moment(jobModel.fin, 'HH:mm:ss')
          });
          setAseguradora(jobModel.aseguradora);
          setActivo(jobModel.activo);
        }
      } catch (error2) {
        errorHandler(error2);
      }
      setLoading(false);
    };
    if (id && form) {
      loadModel();
    }
  }, [id, form]);

  useEffect(() => {
    form.resetFields();
  }, [model, form]);

  const handleChange = async (field, value) => {
    try {
      setDatosCambiados({ ...datosCambiados, [field]: value.target.value });
    } catch (error2) {
      // error
    }
  };

  const showModal = () => {
    if (!(Object.entries(datosCambiados).length === 0)) {
      setVisible(true);
    } else {
      message.warning('No hay datos modificados');
    }
  };

  const handleOk = () => {
    setVisible(false);
    update();
  };

  const handleCancel = () => {
    setVisible(false);
  };
  return (
    <ResponsiveContainer size="large">
      <Card
        title={`${!id ? 'Agregar' : 'Editar'} Tarea Programada`}
        style={{ textAlign: 'left' }}
      >
        <Spin spinning={loading} delay={500} size="large" tip="Cargando...">
          <div style={{ maxWidth: '500px' }}>
            <Form
              {...formItemLayout}
              initialValues={model}
              scrollToFirstError
              form={form}
              name="job"
              autoComplete="off"
              layout="vertical"
              onFinish={onFinish}
            >
              <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
                <Col xs={24} md={24} align="start">
                  <Form.Item
                    label="Aseguradora"
                    name="aseguradora"
                    // rules={[{ required: true, message: 'Requerido' }]}
                  >
                    <AseguradoraSelect handleChange={getAseguradoraId} />
                  </Form.Item>
                </Col>
                <Col xs={24} md={24} align="start">
                  <Form.Item label="Tipo" name="tipo">
                    <Select
                      showSearch
                      filterOption={(input, option) =>
                        option.props.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      style={{ width: '100%' }}
                      optionFilterProp="children"
                      placeholder="Elegir tipo de tarea"
                    >
                      {TIPOS_JOB.map(({ codigo, descripcion }) => (
                        <Option key={codigo} value={codigo}>
                          {codigo} - {descripcion}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
                <Col xs={24} md={24} align="start">
                  <Form.Item
                    label="Descripción"
                    rules={[
                      {
                        required: true,
                        whitespace: true
                      }
                    ]}
                    name="descripcion"
                    onChange={(e) => {
                      // handleChange('Descripción', e);
                      handleChange('descripcion', e);
                    }}
                  >
                    <Input />
                  </Form.Item>
                </Col>
              </Row>
              {id ? (
                <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
                  <Col xs={24} md={24} align="start">
                    <Form.Item
                      label="Activo"
                      rules={[
                        {
                          required: true,
                          whitespace: true
                        }
                      ]}
                    >
                      <Radio.Group
                        value={activo}
                        onChange={(e) => {
                          setActivo(e.target.value);
                        }}
                      >
                        <Radio value>Si</Radio>
                        <Radio value={false}>No</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                </Row>
              ) : (
                <Form.Item label="Activo">
                  <Radio.Group values={false} disabled>
                    <Radio value>Si</Radio>
                    <Radio value={false}>No</Radio>
                  </Radio.Group>
                </Form.Item>
              )}

              <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
                <Col xs={12} md={12} align="start">
                  <Form.Item
                    label="Fecha Inicio"
                    name="inicio"
                    rules={[{ required: true }]}
                  >
                    <CustomDatePicker
                      style={{ width: '100%' }}
                      placeholder="DD/MM/YYYY"
                      format="DD/MM/YYYY"
                    />
                  </Form.Item>
                </Col>
                <Col xs={12} md={12} align="start">
                  <Form.Item
                    label="Hora Inicio"
                    name="hora_inicio"
                    rules={[{ required: true, message: 'Requerido' }]}
                  >
                    <TimePicker style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 0]} style={{ textAlign: 'start' }}>
                <Col xs={12} md={12} align="start">
                  <Form.Item
                    label="Fecha Fin"
                    name="fin"
                    rules={[{ required: true }]}
                  >
                    <CustomDatePicker
                      style={{ width: '100%' }}
                      placeholder="DD/MM/YYYY"
                      format="DD/MM/YYYY"
                    />
                  </Form.Item>
                </Col>
                <Col xs={12} md={12} align="start">
                  <Form.Item
                    label="Hora Fin"
                    name="hora_fin"
                    rules={[{ required: true, message: 'Requerido' }]}
                  >
                    <TimePicker style={{ width: '100%' }} />
                  </Form.Item>
                </Col>
              </Row>

              <Button type="primary" htmlType="submit" icon={<SaveOutlined />}>
                {!id ? 'Guardar' : 'Actualizar'}
              </Button>
            </Form>
          </div>
        </Spin>
      </Card>
      <Modal
        title="Los datos fueron editados. ¿Está seguro de querer guardarlos?"
        open={visible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <>
          {Object.keys(datosCambiados).map((key) => (
            <Row key={key}>
              <Col span={8} align="start">
                <p>{`${key}`}</p>
              </Col>
              <Col span={8} align="start">
                <strong>{`${datosCambiados[key]}`}</strong>
              </Col>
            </Row>
          ))}
        </>
      </Modal>
    </ResponsiveContainer>
  );
};

export default JobForm;
